"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlDecode = htmlDecode;
exports.convertPxToRem = convertPxToRem;
function htmlDecode(inputHtml) {
    if (inputHtml === void 0) { inputHtml = ''; }
    var element = document.createElement('textarea');
    element.innerHTML = inputHtml;
    return element.value;
}
function convertPxToRem(content) {
    if (content === void 0) { content = ''; }
    if (content) {
        return content.replace(/font-size:(\d+)px/g, function (match, pxValue) {
            var remValue = (parseInt(pxValue, 10) / 16).toFixed(3); // Convert px to rem
            return "font-size:".concat(remValue, "rem");
        });
    }
}
//# sourceMappingURL=html.js.map